<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirm']);
const { t } = useI18n();

const dialogRef = ref(null);
const stage = ref(null);
const isDeleting = ref(false);

const description = computed(() =>
  t('KANBAN.STAGE.DELETE.MESSAGE', { name: stage.value?.name || '' })
);

const open = value => {
  stage.value = value;
  dialogRef.value.open();
};

const close = () => dialogRef.value.close();
const setDeleting = value => {
  isDeleting.value = value;
};

defineExpose({ open, close, setDeleting });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('KANBAN.STAGE.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('KANBAN.STAGE.DELETE.CONFIRM')"
    :cancel-button-label="t('KANBAN.STAGE.DELETE.CANCEL')"
    :is-loading="isDeleting"
    width="sm"
    @confirm="emit('confirm', stage)"
  />
</template>
